import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormSelect from 'react-select';

class JobFilter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <FormSelect
                options={this.props.options}
                defaultValue={this.props.options[0]}
                onChange={this.props.onChange}
            />
        );
    }
}

export default JobFilter;
